/**
 * The support flyout's on-screen width. `ChatSupportFlyout/style.scss` sets the same number on
 * `.custom-flyout-contents`, and the two have to agree: the width the flyout renders at and the
 * inset the page owes it are declared in different layers.
 */
export const CHAT_SUPPORT_FLYOUT_WIDTH_PX = 600;

/**
 * Custom property naming how much of the viewport's right edge the support flyout is covering.
 * `Home` publishes it so that a `position: fixed` surface can move out of the flyout's way, which
 * the page inset on its own cannot do.
 */
export const CHAT_SUPPORT_FLYOUT_INSET_PROPERTY = "--chat-support-flyout-inset";
